import { injectable } from 'inversify';
import { ApiResponse } from '../utils/api-response.utils';
import { OscxData } from '../_api/models/oscx.model';
import { ERRORS } from '../constants/errors';
import axiosClient from './axios-client';

@injectable()
export class OSCXService {
  async getOSCXData(
    tab: string,
    channelIds?: number[],
    countryIds?: number[],
    categoryIds?: number[]
  ): Promise<ApiResponse<OscxData>> {
    try {
      const channels = `${channelIds && channelIds.length > 0 ? '&channelIds=' + channelIds?.join(',') : ''}`;
      const country = `${countryIds && countryIds.length > 0 ? '&countryIds=' + countryIds?.join(',') : ''}`;
      const category = `${categoryIds && categoryIds.length > 0 ? '&categoryIds=' + categoryIds?.join(',') : ''}`;
      const response = await axiosClient.get<ApiResponse<OscxData>>(
        `/api/oscx?tab=${tab}${channels}${country}${category}`.trimEnd()
      );
      return response.data;
    } catch (e: any) {
      if (e.response?.status === 403)
        throw new Error(ERRORS.missingSubscription);
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getOSCXCountryFilters(): Promise<
    ApiResponse<{
      countryChannelMap: Record<string, string[]>;
      countryCategoryMap: Record<string, string[]>;
    }>
  > {
    try {
      const response = await axiosClient.get<
        ApiResponse<{
          countryChannelMap: Record<string, string[]>;
          countryCategoryMap: Record<string, string[]>;
        }>
      >('/api/oscx/filters');
      return response.data;
    } catch (e: any) {
      if (e.response?.status === 403)
        throw new Error(ERRORS.missingSubscription);
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
